export const footerMoreLinks = {
  'az-az': [
    {
      title: 'Əlavə',
      items: [
        {
          href: 'https://www.wingie.az/contact/',
          title: 'Əlaqə',
        },

        {
          href: 'https://www.wingie.az/about-us/',
          title: 'Haqqımızda',
        },
        {
          href: 'https://www.wingie.az/privacy/',
          title: 'Məxfilik',
        },
        {
          href: 'https://www.wingie.az/terms-and-conditions/',
          title: 'İstifadə şərtləri',
        },
        {
          href: 'https://www.wingie.az/awards/',
          title: 'Mükafatlarımız',
        },
      ],
    },
  ],
  'az-ru': [
    {
      title: 'Больше',
      items: [
        {
          href: 'https://www.wingie.az/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://www.wingie.az/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://www.wingie.az/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://www.wingie.az/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://www.wingie.az/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'az-en': [
    {
      title: 'More',
      items: [
        { title: 'Contact', href: 'https://www.wingie.az/en/contact/' },
        {
          title: 'Frequently Asked Questions',
          href: 'https://www.wingie.az/en/faq/',
        },

        { title: 'About us', href: 'https://www.wingie.az/en/about-us/' },
        { title: 'Privacy', href: 'https://www.wingie.az/en/privacy/' },
        {
          title: 'Terms and Conditions',
          href: 'https://www.wingie.az/en/terms-and-conditions/',
        },
        {
          title: 'Our Awards',
          href: 'https://www.wingie.az/en/awards/',
        },
      ],
    },
  ],
  'az-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://www.wingie.az/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://www.wingie.az/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://www.wingie.az/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://www.wingie.az/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://www.wingie.az/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://www.wingie.az/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'az-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://www.wingie.az/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://www.wingie.az/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },

        {
          href: 'https://www.wingie.az/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://www.wingie.az/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://www.wingie.az/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://www.wingie.az/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'az-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://www.wingie.az/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://www.wingie.az/ar/faq/',
          title: 'الأسئلة المتكررة',
        },

        {
          href: 'https://www.wingie.az/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://www.wingie.az/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://www.wingie.az/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://www.wingie.az/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'az-it': [
    {
      title: 'Di più',
      items: [
        { title: 'Contatto', href: 'https://www.wingie.az/it/contact/' },
        // { title: 'Domande frequenti', href: 'https://www.wingie.az/it/faq/' },

        { title: 'Chi siamo', href: 'https://www.wingie.az/it/about-us/' },
        { title: 'Privacy', href: 'https://www.wingie.az/it/privacy/' },
        { title: 'Termini e condizioni', href: 'https://www.wingie.az/it/terms-and-conditions/' },
        { title: 'I nostri premi', href: 'https://www.wingie.az/it/awards/' },
      ],
    },
  ],
  'az-fr': [
    {
      title: 'Plus',
      items: [
        { title: 'Contact', href: 'https://www.wingie.az/fr/contact/' },
        // { title: 'Questions fréquemment posées', href: 'https://www.wingie.az/fr/faq/' },

        { title: 'À propos de nous', href: 'https://www.wingie.az/fr/about-us/' },
        { title: 'Confidentialité', href: 'https://www.wingie.az/fr/privacy/' },
        { title: 'Termes et conditions', href: 'https://www.wingie.az/fr/terms-and-conditions/' },
        { title: 'Nos récompenses', href: 'https://www.wingie.az/fr/awards/' },
      ],
    },
  ],
  'az-pt': [
    {
      title: 'Mais',
      items: [
        { title: 'Contacto', href: 'https://www.wingie.az/pt/contact/' },
        // { title: 'Perguntas frequentes', href: 'https://www.wingie.az/pt/faq/' },

        { title: 'Sobre nós', href: 'https://www.wingie.az/pt/about-us/' },
        { title: 'Privacidade', href: 'https://www.wingie.az/pt/privacy/' },
        { title: 'Termos e condições', href: 'https://www.wingie.az/pt/terms-and-conditions/' },
        { title: 'Os nossos prémios', href: 'https://www.wingie.az/pt/awards/' },
      ],
    },
  ],
  'az-ro': [
    {
      title: 'Mai mult',
      items: [
        { title: 'Contact', href: 'https://www.wingie.az/ro/contact/' },
        // { title: 'Întrebări frecvente', href: 'https://www.wingie.az/ro/faq/' },

        { title: 'Despre noi', href: 'https://www.wingie.az/ro/about-us/' },
        { title: 'Confidențialitate', href: 'https://www.wingie.az/ro/privacy/' },
        { title: 'Termeni și condiții', href: 'https://www.wingie.az/ro/terms-and-conditions/' },
        { title: 'Premiile noastre', href: 'https://www.wingie.az/ro/awards/' },
      ],
    },
  ],
  'az-pl': [
    {
      title: 'Więcej',
      items: [
        { title: 'Kontakt', href: 'https://www.wingie.az/pl/contact/' },
        // { title: 'Często zadawane pytania', href: 'https://www.wingie.az/pl/faq/' },

        { title: 'O nas', href: 'https://www.wingie.az/pl/about-us/' },
        { title: 'Prywatność', href: 'https://www.wingie.az/pl/privacy/' },
        { title: 'Warunki użytkowania', href: 'https://www.wingie.az/pl/terms-and-conditions/' },
        { title: 'Nasze nagrody', href: 'https://www.wingie.az/pl/awards/' },
      ],
    },
  ],
  'az-lt': [
    {
      title: 'Daugiau',
      items: [
        { title: 'Kontaktai', href: 'https://www.wingie.az/lt/contact/' },
        // { title: 'Dažnai užduodami klausimai', href: 'https://www.wingie.az/lt/faq/' },

        { title: 'Apie mus', href: 'https://www.wingie.az/lt/about-us/' },
        { title: 'Privatumas', href: 'https://www.wingie.az/lt/privacy/' },
        { title: 'Taisyklės ir sąlygos', href: 'https://www.wingie.az/lt/terms-and-conditions/' },
        { title: 'Mūsų apdovanojimai', href: 'https://www.wingie.az/lt/awards/' },
      ],
    },
  ],
  'az-uz': [
    {
      title: "Ko'proq",
      items: [
        { title: 'Aloqa', href: 'https://www.wingie.az/uz/contact/' },
        // { title: 'Tez-tez beriladigan savollar', href: 'https://www.wingie.az/uz/faq/' },

        { title: 'Biz haqimizda', href: 'https://www.wingie.az/uz/about-us/' },
        { title: 'Maxfiylik', href: 'https://www.wingie.az/uz/privacy/' },
        { title: 'Shartlar va qoidalar', href: 'https://www.wingie.az/uz/terms-and-conditions/' },
        { title: 'Bizning mukofotlarimiz', href: 'https://www.wingie.az/uz/awards/' },
      ],
    },
  ],
  'az-sr': [
    {
      title: 'Više',
      items: [
        { title: 'Kontakt', href: 'https://www.wingie.az/sr/contact/' },
        // { title: 'Često postavljana pitanja', href: 'https://www.wingie.az/sr/faq/' },

        { title: 'O nama', href: 'https://www.wingie.az/sr/about-us/' },
        { title: 'Privatnost', href: 'https://www.wingie.az/sr/privacy/' },
        { title: 'Uslovi korišćenja', href: 'https://www.wingie.az/sr/terms-and-conditions/' },
        { title: 'Naše nagrade', href: 'https://www.wingie.az/sr/awards/' },
      ],
    },
  ],
  'az-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { title: 'Байланыш', href: 'https://www.wingie.az/ky/contact/' },
        // { title: 'Көп берилүүчү суроолор', href: 'https://www.wingie.az/ky/faq/' },

        { title: 'Биз жөнүндө', href: 'https://www.wingie.az/ky/about-us/' },
        { title: 'Купуялык', href: 'https://www.wingie.az/ky/privacy/' },
        { title: 'Эрежелер жана шарттар', href: 'https://www.wingie.az/ky/terms-and-conditions/' },
        { title: 'Биздин сыйлыктар', href: 'https://www.wingie.az/ky/awards/' },
      ],
    },
  ],
  'az-tg': [
    {
      title: 'Бештар',
      items: [
        { title: 'Алоқа', href: 'https://www.wingie.az/tg/contact/' },
        // { title: 'Савол-ҷавобҳои зиёд', href: 'https://www.wingie.az/tg/faq/' },

        { title: 'Дар бораи мо', href: 'https://www.wingie.az/tg/about-us/' },
        { title: 'Махфият', href: 'https://www.wingie.az/tg/privacy/' },
        { title: 'Шартҳо ва қоидаҳо', href: 'https://www.wingie.az/tg/terms-and-conditions/' },
        { title: 'Мукофотҳои мо', href: 'https://www.wingie.az/tg/awards/' },
      ],
    },
  ],
  'az-kk': [
    {
      title: 'Көбірек',
      items: [
        { title: 'Байланыс', href: 'https://www.wingie.az/kk/contact/' },
        // { title: 'Жиі қойылатын сұрақтар', href: 'https://www.wingie.az/kk/faq/' },

        { title: 'Біз туралы', href: 'https://www.wingie.az/kk/about-us/' },
        { title: 'Құпиялылық', href: 'https://www.wingie.az/kk/privacy/' },
        { title: 'Ережелер мен шарттар', href: 'https://www.wingie.az/kk/terms-and-conditions/' },
        { title: 'Біздің марапаттар', href: 'https://www.wingie.az/kk/awards/' },
      ],
    },
  ],
  'az-nl': [
    {
      title: 'Meer',
      items: [
        { title: 'Contact', href: 'https://www.wingie.az/nl/contact/' },
        // { title: 'Veelgestelde vragen', href: 'https://www.wingie.az/nl/faq/' },

        { title: 'Over ons', href: 'https://www.wingie.az/nl/about-us/' },
        { title: 'Privacy', href: 'https://www.wingie.az/nl/privacy/' },
        { title: 'Algemene voorwaarden', href: 'https://www.wingie.az/nl/terms-and-conditions/' },
        { title: 'Onze onderscheidingen', href: 'https://www.wingie.az/nl/awards/' },
      ],
    },
  ],
  'az-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://www.wingie.az/ja/contact/' },
        { title: 'よくある質問', href: 'https://www.wingie.az/en/faq/' },
        { title: '会社概要', href: 'https://www.wingie.az/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://www.wingie.az/ja/privacy/' },
        { title: '利用規約', href: 'https://www.wingie.az/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://www.wingie.az/ja/awards/' },
      ],
    },
  ],
  'az-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://www.wingie.az/zh/contact/' },
        { title: '常见问题', href: 'https://www.wingie.az/en/faq/' },
        { title: '关于我们', href: 'https://www.wingie.az/zh/about-us/' },
        { title: '隐私政策', href: 'https://www.wingie.az/zh/privacy/' },
        { title: '条款和条件', href: 'https://www.wingie.az/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://www.wingie.az/zh/awards/' },
      ],
    },
  ],
  'az-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://www.wingie.az/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://www.wingie.az/en/faq/' },
        { title: '회사 소개', href: 'https://www.wingie.az/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://www.wingie.az/ko/privacy/' },
        { title: '이용약관', href: 'https://www.wingie.az/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://www.wingie.az/ko/awards/' },
      ],
    },
  ],
  'az-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://www.wingie.az/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://www.wingie.az/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://www.wingie.az/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://www.wingie.az/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://www.wingie.az/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://www.wingie.az/hi/awards/' },
      ],
    },
  ],
  'az-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://www.wingie.az/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://www.wingie.az/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://www.wingie.az/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://www.wingie.az/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://www.wingie.az/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://www.wingie.az/ta/awards/' },
      ],
    },
  ],
  'az-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://www.wingie.az/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://www.wingie.az/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://www.wingie.az/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://www.wingie.az/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://www.wingie.az/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://www.wingie.az/th/awards/' },
      ],
    },
  ],
  'az-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://www.wingie.az/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://www.wingie.az/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://www.wingie.az/ur/about-us/' },
        { title: 'رازداری', href: 'https://www.wingie.az/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://www.wingie.az/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://www.wingie.az/ur/awards/' },
      ],
    },
  ],
  'az-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://www.wingie.az/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://www.wingie.az/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://www.wingie.az/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://www.wingie.az/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://www.wingie.az/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://www.wingie.az/ka/awards/' },
      ],
    },
  ],
}
